var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.dialog_edit,
            callback: function ($$v) {
              _vm.dialog_edit = $$v
            },
            expression: "dialog_edit",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v("Edit level: " + _vm._s(_vm.dialog_edit_index)),
              ]),
              _c("v-card-text", [
                _vm._v("Select used colors and type of cauldron."),
              ]),
              _vm.model.levels[_vm.dialog_edit_index]
                ? _c("v-text-field", {
                    staticClass: "ma-3 mt-n2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      label: "Colors",
                      rules: _vm.colorsRule,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.validateDialogColorInput(
                          _vm.dialog_edit_index
                        )
                      },
                    },
                    model: {
                      value: _vm.model.levels[_vm.dialog_edit_index].colors,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model.levels[_vm.dialog_edit_index],
                          "colors",
                          $$v
                        )
                      },
                      expression: "model.levels[dialog_edit_index].colors",
                    },
                  })
                : _vm._e(),
              _vm.model.levels[_vm.dialog_edit_index]
                ? _c("v-autocomplete", {
                    staticClass: "ma-3 mt-n4",
                    attrs: {
                      items: _vm.cauldrons,
                      "item-text": "name",
                      "return-object": "",
                      outlined: "",
                      dense: "",
                      label: "Cauldron Type",
                    },
                    model: {
                      value: _vm.model.levels[_vm.dialog_edit_index].cauldron,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model.levels[_vm.dialog_edit_index],
                          "cauldron",
                          $$v
                        )
                      },
                      expression: "model.levels[dialog_edit_index].cauldron",
                    },
                  })
                : _vm._e(),
              _vm.model.levels[_vm.dialog_edit_index]
                ? _c("v-checkbox", {
                    staticClass: "ma-3 mt-n6",
                    attrs: { label: "Show Extra Rewards" },
                    model: {
                      value:
                        _vm.model.levels[_vm.dialog_edit_index]
                          .show_extra_rewards,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model.levels[_vm.dialog_edit_index],
                          "show_extra_rewards",
                          $$v
                        )
                      },
                      expression:
                        "model.levels[dialog_edit_index].show_extra_rewards",
                    },
                  })
                : _vm._e(),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog_edit = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                "Ancient Treasure Bundle (" + _vm._s(this.rules.name) + ")"
              ),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4 pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    directives: [
                      { name: "ascii-only", rawName: "v-ascii-only" },
                    ],
                    staticClass: "mr-2",
                    attrs: { label: "Name" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "model.name",
                    },
                  }),
                  _c("v-text-field", {
                    directives: [
                      { name: "ascii-only", rawName: "v-ascii-only" },
                    ],
                    attrs: { label: "Key" },
                    model: {
                      value: _vm.model.key,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model,
                          "key",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "model.key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "purple--text pa-0 ma-0 ml-1" },
                        [_vm._v("Bottles currency")]
                      ),
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "ma-0 pa-1",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c("r-currency-kind-dropdown", {
                            attrs: {
                              model: _vm.model.merge_currency,
                              label: "Merge currency",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "merge_currency",
                                  $event
                                )
                              },
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "ml-1 mr-1 mt-n6 purple--text" },
                            [_vm._v(" / ")]
                          ),
                          _c("v-text-field", {
                            staticClass: "mt-1",
                            staticStyle: { width: "80px" },
                            attrs: {
                              "hide-details": "",
                              type: "number",
                              label: "Multiply",
                              rules: _vm.multiplyRule,
                            },
                            on: { input: _vm.validateMultiplyInput },
                            model: {
                              value: _vm.model.merge_currency_multiply,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "merge_currency_multiply",
                                  $$v
                                )
                              },
                              expression: "model.merge_currency_multiply",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "ml-1 mr-1 mt-n6 purple--text" },
                            [_vm._v(" = ")]
                          ),
                          _c("r-currency-kind-dropdown", {
                            attrs: {
                              model: _vm.model.bottle_currency,
                              label: "Bottle currency",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "bottle_currency",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "orange--text pa-0 ma-0 ml-1" },
                        [_vm._v("Progress currency")]
                      ),
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "ma-0 pa-1",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c("r-currency-kind-dropdown", {
                            attrs: {
                              model: _vm.model.progress_currency,
                              label: "Pass progress currency",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "progress_currency",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "green--text pa-0 ma-0 ml-1" },
                        [_vm._v("Products")]
                      ),
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "ma-0 pa-1",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c("r-product-dropdown", {
                            attrs: {
                              model: _vm.model.product,
                              groups: _vm.groups_product,
                              label: "Premium",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "product", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "ma-0 pa-1",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "orange--text pa-0 ma-0 ml-1" },
                            [_vm._v("Levels")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "green--text",
                              attrs: {
                                icon: "",
                                elevation: "0",
                                color: "white",
                                dense: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.row_add()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-plus")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "ma-0 pa-1",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c("v-data-table", {
                            staticStyle: {
                              "white-space": "nowrap",
                              width: "100%",
                            },
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.model.levels,
                              height:
                                _vm.model.levels.length > 7
                                  ? 32 * 7 + 32 + 16
                                  : undefined,
                              "item-key": "none",
                              "disable-pagination": "",
                              "hide-default-footer": "",
                              dense: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.colors",
                                fn: function ({ item }) {
                                  return [
                                    _vm._v(" " + _vm._s(item.colors) + " "),
                                  ]
                                },
                              },
                              {
                                key: "item.cauldron",
                                fn: function ({ item }) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.cauldron.name) + " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.show_extra_rewards",
                                fn: function ({ item }) {
                                  return [
                                    item.show_extra_rewards == true
                                      ? _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              small: "",
                                              large: "",
                                              color: "green darken-2",
                                            },
                                          },
                                          [_vm._v(" mdi-check-bold ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function ({ item, index }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.row_edit(index)
                                          },
                                        },
                                      },
                                      [_vm._v("mdi-pencil")]
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.row_moveup(index)
                                          },
                                        },
                                      },
                                      [_vm._v("mdi-arrow-up-thick")]
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.row_movedown(index)
                                          },
                                        },
                                      },
                                      [_vm._v("mdi-arrow-down-thick")]
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.row_remove(index)
                                          },
                                        },
                                      },
                                      [_vm._v("mdi-delete")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "blue--text pa-0 ma-0 ml-1 mb-2" },
                        [_vm._v("Reward Tracks")]
                      ),
                      _c(
                        "v-expansion-panels",
                        [
                          _c("r-reward-bunch-panel", {
                            attrs: {
                              model: _vm.model.rewards,
                              title: "Default",
                              label: "Reward",
                              points: true,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "rewards", $event)
                              },
                            },
                          }),
                          _c("r-reward-bunch-panel", {
                            attrs: {
                              model: _vm.model.rewards_premium,
                              title: "Premium",
                              label: "Reward",
                              points: true,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "rewards_premium",
                                  $event
                                )
                              },
                            },
                          }),
                          _c("r-reward-bunch-panel", {
                            attrs: {
                              model: _vm.model.rewards_exchange,
                              title: "Exchange",
                              label: "Reward",
                              points: true,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "rewards_exchange",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "red--text pa-0 ma-0 ml-1 mb-2" },
                        [_vm._v("Guards")]
                      ),
                      _c(
                        "v-expansion-panels",
                        [
                          _c("r-guard-panel", {
                            attrs: {
                              model: _vm.model.guard,
                              title: "Guard Config",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "guard", $event)
                              },
                            },
                          }),
                          _c("r-guard-money-panel", {
                            attrs: {
                              model: _vm.model.guardMoney,
                              title: "Guard Money",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "guardMoney", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "red--text pa-0 ma-0 ml-1 mb-2" },
                        [_vm._v("Reward on merge")]
                      ),
                      _c(
                        "v-expansion-panels",
                        [
                          _c("r-reward-panel", {
                            attrs: {
                              model: _vm.model.rewardOnMerge,
                              title: "Reward on merge",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.model,
                                  "rewardOnMerge",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }